import { render, staticRenderFns } from "./CustomerAccountCard.vue?vue&type=template&id=0cbc41ab&scoped=true&"
import script from "./CustomerAccountCard.vue?vue&type=script&lang=js&"
export * from "./CustomerAccountCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbc41ab",
  null
  
)

export default component.exports